<template>
  <div class="calendar monthly-calendar">
    <div class="calendar-header">
      <div
        v-for="dayInWeek in daysInWeek"
        class="calendar-header__day-of-week"
      >
        {{ dayInWeek }}
      </div>
    </div>
    <div
      v-loading="loading"
      class="calendar-body"
    >
      <div class="calendar-schedule">
        <div
          v-for="(week, weekIndex) in datesByWeeks"
          class="week"
        >
          <div
            v-for="(day, dayIndex) in week"
            class="day"
            :class="{'inactive': !isSameMonth(day)}"
            @click="handleClickDate(day)"
          >
            <div class="day__header">
              <div class="day__date">
                {{ presentDayTitle(day) }}
                <div
                  v-show="isBookingSystem"
                  class="dayoff-icon"
                  :class="presentDayOffClass(day)"
                  @click.stop="handleClickBlocking(day)"
                />
              </div>
            </div>

            <DailySchedulesInMonth
              :child-courses="childCourses[weekIndex * 7 + dayIndex]"
              @select="onSelectScheduleItem"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import _ from "lodash";
import DailyScheduleItem from "./DailyScheduleItem";
import DailySchedulesInMonth from "./DailySchedulesInMonth";

export default {
	name: "ScheduleCalandarByMonthly",
	components: {
		DailySchedulesInMonth,
		DailyScheduleItem,
	},
	props: ["curDate", "dates", "loading"],
	data() {
		return {
			daysInWeek: ["일", "월", "화", "수", "목", "금", "토"],
			days: [],
		};
	},
	computed: {
		childCourses() {
			return this.$store.getters.getChildCoursesByDates(this.dates);
		},
		datesByWeeks() {
			return _.chunk(this.dates, 7);
		},
		blockings() {
			return this.$store.getters.getBlockings;
		},
		isBookingSystem() {
			return this.$store.getters.getIsBookingSystem;
		},
	},
	methods: {
		presentDayOffClass(date) {
			const blocking = this.blockings[new Date(date).toDateFormat()];

			return {
				"has-dayoff": blocking ? blocking.length > 0 : false,
			};
		},
		presentDayTitle(date) {
			return dateFns.format(date, "D일");
		},
		isSameMonth(date) {
			return dateFns.isSameMonth(this.curDate, date);
		},
		handleClickDate(date) {
			this.$emit("clickDate", date);
		},
		handleClickBlocking(date) {
			const blocking = this.blockings[new Date(date).toDateFormat()];

			if (!blocking || blocking.length === 0) {
				return this.$emit("clickBlocking", {
					start: date,
				});
			}

			return this.$emit("clickBlocking", blocking[0]);
		},
		onSelectScheduleItem(value) {
			this.$emit("select", value);
		},
	},
};
</script>

<style lang="scss">
.monthly-calendar {
	.calendar-header {
		margin-left: 0;
		width: 100%;
		height: 45px;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		background-color: rgba(200, 200, 200, 0.5);

		.calendar-header__day-of-week {
			display: inline-block;
			position: relative;
			width: calc(100% / 7);
			font-size: 13px;
			color: #4a4a4a;
			letter-spacing: -0.8px;
			text-align: center;
			line-height: 45px;
		}
	}

	.calendar-schedule {
		position: relative;
		width: 100%;
		height: calc(100vh - 275px);
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		background-color: white;
		overflow-y: auto;

		.week {
			height: calc(100% / 6);
			min-height: 110px;

			.day {
				float: left;
				display: inline-block;
				width: calc(100% / 7);
				height: 100%;
				box-sizing: border-box;
				border-right: 1px solid #f2f2f2;
				border-bottom: 1px solid #f2f2f2;
				color: #4a4a4a;
				cursor: pointer;

				.day__header {
					padding: 9px;
					text-align: right;

					.day__date {
						display: inline-block;
						font-size: 14px;
						letter-spacing: -0.8px;
						position: relative;

						.dayoff-icon {
							position: absolute;
							top: 3px;
							left: -20px;
							display: inline-block;

							&.has-dayoff {
								color: #4a4a4a;
								background-image: url("/image/icon/icon/dayoff/on.svg");
							}
						}
					}
				}

				.more-schedule {
					font-weight: 300;
					padding-left: 20px;
					line-height: 20px;
					font-size: 12px;
					color: #4a4a4a;
					letter-spacing: -0.69px;
				}

				&.inactive {
					color: #d3d3d3;
				}

				&:last-child {
					border-right: none;
				}

				&:hover {
					font-weight: bold;
					background-color: #d3d3d3;

					.dayoff-icon {
						background-image: url("/image/icon/icon/dayoff/hover.svg");
					}
				}
			}

			&:last-child {
				border-bottom: none;
			}
		}
	}
}
</style>
